import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

export interface ActionConfirmationDialogProps {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    confirmationMessage: string;
    confirmedParentAction: () => void;
    submitButtonName?: string | null;
    doAfterConfirmation?: () => void;
}

export function ActionConfirmationDialog({
    isOpen,
    setIsOpen,
    confirmationMessage,
    confirmedParentAction,
    submitButtonName,
    doAfterConfirmation,
}: ActionConfirmationDialogProps) {
    const handleClose = (): void => {
        setIsOpen(false);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
        event.preventDefault();
        confirmedParentAction();
        setIsOpen(false);
        
        if (doAfterConfirmation != null) {
            doAfterConfirmation();
        }
    }
    
    return (
        <Dialog
            open={isOpen}
            onClose={() => setIsOpen(false)}
            PaperProps={{
                component: 'form',
                onSubmit: handleSubmit,
            }}
        >
            <DialogTitle>{confirmationMessage}</DialogTitle>
            <DialogActions>
                <Button
                    sx={{ fontWeight: "bold" }}
                    onClick={handleClose}
                >
                    Cancel
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    type="submit"
                >
                    {submitButtonName != null
                        ? submitButtonName
                        : "Confirm"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}